import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';
import FeaturedIconList, { FeaturedIconListProps } from 'molecules/FeaturedIconList/FeaturedIconList';
import HeadingAndSupportingText, {
  HeadingAndSupportingTextProps,
} from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import React from 'react';

interface FeaturedIconListsWithTextBlockProps {
  headingAndSupportingText: HeadingAndSupportingTextProps;
  featuredIconLists: FeaturedIconListProps[];
}

const FeaturedIconListsWithTextBlock = ({
  headingAndSupportingText,
  featuredIconLists,
}: FeaturedIconListsWithTextBlockProps): JSX.Element => (
  <Grid
    totalColumns={1}
    gap='spacing-7xl'
    gapSm='spacing-6xl'
  >
    <Stack
      maxWidth='width-xl'
      marginRight='spacing-auto'
    >
      <HeadingAndSupportingText {...headingAndSupportingText} />
    </Stack>
    {featuredIconLists.map((list, index) => (
      <Stack key={index}>
        <FeaturedIconList {...list} />
      </Stack>
    ))}
  </Grid>
);

export default FeaturedIconListsWithTextBlock;
